import { Box, type BoxProps } from '@mui/material';
import { TabsProps } from './Tabs';

export type TabPanelProps = BoxProps & {
  rootProps?: Omit<React.HTMLProps<HTMLDivElement>, 'role' | 'hidden' | 'aria-labelledby'>;
  children: React.ReactNode;
  value?: TabsProps['value'];
  tabValue?: string;
};

export const TabPanel = ({ rootProps, children, value, tabValue, ...restProps }: TabPanelProps) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== tabValue}
      id={`tabpanel-${tabValue}`}
      aria-labelledby={`tab-${tabValue}`}
      {...rootProps}
    >
      {value === tabValue && (
        <Box sx={{ p: 3 }} {...restProps}>
          {children}
        </Box>
      )}
    </div>
  );
};
